import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { AdminTestContext } from '@orientaction/Context';
import CircledElement from '@orientaction/commons/CircledElement';
import { publicIconPath } from '@orientaction/utils';
import { FC, useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';
import style from './style';

interface IProps {
  response: any;
  index: number;
}

const ResponseItem: FC<IProps> = ({ response, index }) => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const classes = style();

  const handleDelete = () => {
    const toDeleteResponse = test?.questionToCreate?.responses[index];
    const { isNew } = toDeleteResponse;
    const toDeleteResponsesIds = isNew
      ? test?.toDeleteResponsesIds
      : [...test?.toDeleteResponsesIds, toDeleteResponse?.id];
    updateTest({
      questionToCreate: {
        ...test.questionToCreate,
        responses: (test?.questionToCreate?.responses || []).filter(
          (resp: any) => resp.id !== test?.questionToCreate?.responses[index]?.id
        ),
      },
      toDeleteResponsesIds,
    });
  };

  const handleEdit = () => {
    updateTest({ responseToEdit: response, responseDrawerOpen: true });
  };

  // fetch variable name from variable object to always get the latest update
  const variableName = (test?.variables || [])
    .filter((v: any) => {
      // S'assurer que response?.variable est traité comme un tableau, même s'il s'agit d'un seul objet ou est undefined/null
      const responseVariables = response?.variable;
      const variablesArray = Array.isArray(responseVariables)
        ? responseVariables
        : responseVariables
        ? [responseVariables]
        : [];

      return variablesArray.some((rv: any) => rv?.id === v?.id);
    })
    .map((v: any) => v?.name)
    .join(', ');

  const { diagram } = test.test;

  const isInterval = diagram?.id === 4;
  const hasImage = response?.image && response.image.length > 0;

  return (
    <Card className={classes.cardContainer} variant="outlined">
      {hasImage ? (
        // Layout FLEXBOX pour les images - STRUCTURE COMPLETE REFAITE
        <div className={classes.imageLayout}>
          <div className={classes.circleContainer}>
            <CircledElement>
              <span className={classes.number}>N°{index + 1}</span>
            </CircledElement>
          </div>
          
          <div className={classes.imageContainer}>
            <img 
              src={response.image} 
              alt={`Réponse ${index + 1}`}
              className={classes.responseImage}
            />
          </div>
          
          <div className={classes.textInfoContainer}>
            {!isInterval && (
              <div className={classes.infoItem}>
                <Typography className={classes.responseVariableLabel} component="div">
                  Variable liée :
                </Typography>
                <Typography className={classes.responseVariableName} component="div">
                  {variableName}
                </Typography>
              </div>
            )}
            <div className={classes.infoItem}>
              <Typography className={classes.responseVariableLabel} component="div">
                Valeur : <span className={classes.responseVariableName} style={{display: 'inline'}}>{response?.variableValue}</span>
              </Typography>
            </div>
          </div>
          
          <div className={classes.actionsContainer}>
            <IconButton className={classes.iconButton} onClick={handleEdit}>
              <img src={`${publicIconPath}/oa_edit.svg`} alt="Edit Icon" />
            </IconButton>
            <IconButton className={classes.iconButton} onClick={handleDelete}>
              <img src={`${publicIconPath}/oa_trash.svg`} alt="Custom Icon" />
            </IconButton>
          </div>
        </div>
      ) : (
        // Layout FLEXBOX pour le texte - STRUCTURE REFAITE AUSSI
        <div className={classes.textLayout}>
          <div className={classes.circleContainer}>
            <CircledElement>
              <span className={classes.number}>N°{index + 1}</span>
            </CircledElement>
          </div>
          
          <div className={classes.textContentContainer}>
            <Typography className={classes.responseTitle}>
              {ReactHtmlParser(response.title)}
            </Typography>
            
            {!isInterval && (
              <div className={classes.itemContainer}>
                <Typography className={classes.responseVariableLabel} component="span">
                  Restitutions liées :
                </Typography>
                <Typography className={classes.responseVariableName} component="p">
                  {variableName}
                </Typography>
              </div>
            )}
            
            <div className={classes.itemContainer}>
              <Typography className={classes.responseVariableLabel} component="span">
                {isInterval ? 'Score : ' : 'Valeur : '} {response?.variableValue}
              </Typography>
            </div>
          </div>
          
          <div className={classes.actionsContainer}>
            <IconButton className={classes.iconButton} onClick={handleEdit}>
              <img src={`${publicIconPath}/oa_edit.svg`} alt="Edit Icon" />
            </IconButton>
            <IconButton className={classes.iconButton} onClick={handleDelete}>
              <img src={`${publicIconPath}/oa_trash.svg`} alt="Custom Icon" />
            </IconButton>
          </div>
        </div>
      )}
    </Card>
  );
};

export default ResponseItem;
